import axios from "axios";
import { env } from "./config/env";

export async function isAuthenticated() {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    await axios.get(`${env.API_BASE_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return true;
  } catch {
    return false;
  }
}
